/**
 * Login Page
 *
 * @module page-login
 * @version 1.0.0
 * @extends HTMLElement
 */

import getValueFromQueryParams from "../utils/parse-query-params";

customElements.component = 'page-login';

if (!customElements.get(customElements.component)) {

  class componentLoginForm extends HTMLElement {

    constructor() {

      super();

      window.localStorage.removeItem("last_viewed_showroom");
      const inviteToken = window.localStorage.getItem("invite_token");
      const inviteToShowroomId = window.localStorage.getItem("inviteToShowroomId");
      this.submitForgotPasswordButton = this.querySelector(".js-submit-forgot-password");

      if (inviteToken && inviteToShowroomId) {
        this.form = this.querySelector("form");

        this.form.innerHTML += `<input type="hidden" name="return_to" value="/pages/showroom-event?id=${inviteToShowroomId}"/>`
      }

      this.checkIsFromShowroom();
      this.addBtnCancelForgotPasswordBehavior();
      this.addBtnForgotPasswordBehavior();
      this.checkUrlHash();
      this.handleSubmitForgotPassword();
    }

    /**
     * Listen forgot password button
     *
     * @return {undefined}
     */
    addBtnForgotPasswordBehavior() {
      let btn = this.querySelector('[data-recover-password-btn]');
      if (!btn) {
        return;
      }
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        this.showRecoverPasswordForm()
        window.location.hash = "#recover"
      });
    }

    /**
     * Listen forgot password cancel button
     *
     * @return {undefined}
     */
    addBtnCancelForgotPasswordBehavior() {
      let btn = this.querySelector('[data-btn-cancel-forgot-password]');
      if (!btn) {
        return;
      }

      btn.addEventListener("click", (e) => {
        this.showRecoverPasswordForm();
      });
    }

    /**
     * Show recover password form
     *
     * @return {undefined}
     */
    showRecoverPasswordForm() {
      let recoverForm = this.querySelector('[data-recover-password-form]');
      let loginForm = this.querySelector('[data-customer-login-form]');

      if (!recoverForm) {
        return;
      }

      if (recoverForm.classList.contains('hidden')) {
        recoverForm.classList.remove('hidden');
        loginForm.classList.add('hidden');
      } else {
        recoverForm.classList.add('hidden');
        loginForm.classList.remove('hidden');
      }
    }

    /**
     * Check the current URL
     *
     * @return {undefined}
     */
    checkUrlHash() {
      var hash = window.location.hash;

      if (hash === '#recover') {
        this.showRecoverPasswordForm();
      } else {
        recoverForm.classList.add('hidden');
        loginForm.classList.remove('hidden');
      }
    }

    checkIsFromShowroom() {
      const isFromShowroom = getValueFromQueryParams("from-showroom");

      if (isFromShowroom) {
        this.querySelector("form").innerHTML += `<input type="hidden" name="return_to" value="/pages/showroom-event">`;
      }
    }

    submitForgotPassword(event) {
      const emailInput = this.querySelector("#RecoverEmail");
      const errorMessage = this.querySelector(".message--error-validation");
      const email = emailInput.value.trim();
      const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

      if (!email || !emailRegex.test(email)) {
        errorMessage.classList.remove("hidden");

        return;
      }

      errorMessage.classList.add("hidden");
      event.currentTarget.nextElementSibling.click();
    }

    handleSubmitForgotPassword() {
      this.submitForgotPasswordButton.addEventListener("click", (e) => {
        e.preventDefault();

        this.submitForgotPassword(e);
      });
    }
  }

  customElements.define(customElements.component, componentLoginForm);
}
